import React, { useState } from 'react'

export const SavedPathContext = React.createContext()

export const withSavedPathContext = Component => props => {
	const [pathState, setPathState] = useState({})
	const value = {
		...pathState,
		setPath(sectionName, pathValue) {
			setPathState({
				...pathState,
				[sectionName]: pathValue
			})
		}
	}
	return(
		<SavedPathContext.Provider value={value}>
			<Component {...props}/>
		</SavedPathContext.Provider>
	)
}
